import { Component, OnInit } from '@angular/core';
import {
	constants,
	AppConfigService,
	LocalStorageService
} from '@edassist/common';

@Component({
	selector: 'ea-client-logo',
	templateUrl: './client-logo.component.html',
	styleUrls: ['./client-logo.component.scss']
})
export class ClientLogoComponent implements OnInit {
	clientLogoUrl: string;
	constants = constants;
	altText: string = 'Client Logo';

	ngOnInit(): void {
		const clientName = LocalStorageService.getItem(
			constants.localStorageKeys.CLIENT_DETAILS
		)?.name;
		if (clientName) {
			this.altText = `${clientName} Logo`;
		}
		this.clientLogoUrl = `${AppConfigService.getSettings().endPoints.cdn}
		${LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS)?.clientLogo}`;
	}
}
